export default "__VITE_ASSET__DPpihC93__"